/**
 * Rounds a number to two decimal places using Decimal.js for precision.
 *
 * @param num The number to round.
 * @returns The number rounded to two decimal places.
 */
export const roundToTwoDecimalsNumber = (num: number): number => {
  // Reproduit le comportement de Decimal.js toDecimalPlaces(2)
  const stringNumber = num.toString();
  const dotIndex = stringNumber.indexOf('.');

  if (isInteger(dotIndex)) {
    return num;
  }

  const integerPart = stringNumber.slice(0, dotIndex);
  const decimalPart = stringNumber.slice(dotIndex + 1);

  if (decimalPart.length <= 2) {
    return num;
  }

  return roundThreeDecimalsNumber(decimalPart, integerPart);
};

export const roundToTwoDecimalsString = (num: number): string => {
  return roundToTwoDecimalsNumber(num).toFixed(2);
};

const isInteger = (dotIndex: number): boolean => {
  return dotIndex === -1;
};

const roundThreeDecimalsNumber = (decimalPart: string, integerPart: string) => {
  const firstTwoDecimals = decimalPart.slice(0, 2);
  const thirdDecimal = parseInt(decimalPart[2]);

  let roundedDecimals = parseInt(firstTwoDecimals);
  if (thirdDecimal >= 5) {
    roundedDecimals += 1;
  }

  if (roundedDecimals >= 100) {
    return roundToHigherInteger(integerPart);
  }

  const formattedDecimals = roundedDecimals.toString().padStart(2, '0');
  return parseFloat(`${integerPart}.${formattedDecimals}`);
};

const roundToHigherInteger = (integerPart: string): number => {
  return parseInt(integerPart) + 1;
};
